import { cn } from "../../../utils";
import { TitleProps } from "../types";

export const Title = ({ children, description, className }: TitleProps) => (
  <div className={cn("space-y-1", className)}>
    <h2 className="flex items-center gap-2.5 text-2xl text-white">
      {children}
    </h2>
    {description && (
      <span className="text-sm text-purple-muted-300">{description}</span>
    )}
  </div>
);
